/**
 * ColumnHeatmapRow — `column.heatmap` renderer. 2-D grid over a
 * `(number, tensor)` source. Reserved — tensor cardinality is not yet
 * implemented; mirrors the current `HeatmapRow` stub.
 */

import { RendererRow } from "./renderer-row.ts";
import { SourceRow } from "./source-row.ts";

/**
 * The `column.heatmap` renderer row over a tensor source (reserved: tensor cells are not
 * implemented yet).
 */
export class ColumnHeatmapRow extends RendererRow {
  get source(): SourceRow {
    const p = this.parent;
    if (!(p instanceof SourceRow)) {
      throw new Error(
        `ColumnHeatmapRow: parent of ${this.id.rawId} is not a SourceRow ` +
          `(got ${p?.constructor.name ?? "undefined"}).`,
      );
    }
    return p;
  }

  grid(): readonly (readonly number[])[] {
    throw new Error(
      "ColumnHeatmapRow.grid: reserved — tensor cardinality not yet implemented.",
    );
  }
}
